import { NuroDenki } from '@/types/api/mypage/options';
import { atom } from 'recoil';
import persistAtom from './recoilPersist';

/**
 * NURO でんきオプション情報を保持する state。
 * サブステータスを基に申込変更・解約導線を出し分けるため、取得済み状態を保持する。
 */
export const NuroDenkiOptionInfoState = atom<NuroDenki>({
  key: 'nuroDenkiOptionInfoState',
  default: {
    nurodenki_sub_status: '',
  },
  effects_UNSTABLE: [persistAtom],
});

export default NuroDenkiOptionInfoState;
